import { Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { PHONE_DISPLAY, PHONE_TEL } from "@/constants/brand";

const LINKS = [
  { href: "#stations", label: "Stations" },
  { href: "#pnr", label: "PNR Status" },
  { href: "#order", label: "Order" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-amber-900/10 bg-[#FFFBEB]/80 backdrop-blur-xl" data-testid="navbar">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <a href="#top" data-testid="nav-home-link" aria-label="Jain Food on Train home">
          <Logo />
        </a>
        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-semibold text-emerald-950/70 transition-colors hover:text-amber-700"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="hidden items-center gap-2 rounded-full border border-emerald-900/20 px-4 py-2 text-sm font-bold text-emerald-900 transition-colors hover:bg-emerald-900 hover:text-amber-50 sm:inline-flex"
          >
            <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
          </a>
          <a
            href="#order"
            data-testid="nav-order-button"
            className="rounded-full bg-amber-600 px-5 py-2 text-sm font-bold text-amber-50 shadow-lg shadow-amber-600/25 transition-colors hover:bg-amber-700"
          >
            Order Now
          </a>
        </div>
      </div>
    </header>
  );
}
